import React, { useEffect, useState } from 'react';
import { baseUrl } from '../../config';
import { useSelector } from 'react-redux';
import { IAuthResponse } from './../../Interfaces';

import { DataGrid, GridColDef, GridColTypeDef, GridRowParams, GridValueFormatterParams } from '@mui/x-data-grid';
import { useNavigate, useParams } from 'react-router-dom';
import { HistoryResponse, defaultHistoryReposnse } from './IHistory';

const History = ( ) => {
    const bearerToken:IAuthResponse  = useSelector( (state:IAuthResponse) => state)
    const navigate = useNavigate();
    const { guid } = useParams();
    const [history, setHistory] = useState<HistoryResponse>(defaultHistoryReposnse);
    const [isLoaded,  setIsLoaded] = useState(false);
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    const [, setError] = useState('');
    useEffect(() => {
        const fetchData = async () => {
          const url = baseUrl + 'History/' + guid;
          try {
            const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + bearerToken.token,
                'Content-Type': 'application/json'
              }
          });
            if (!response.ok) {
              setError('Network response was not ok')
            }
            const jsonData:HistoryResponse = await response.json();


            setHistory(jsonData);
            setIsLoaded(true);
            setError('');
          } catch (error) {
            console.error('Error fetching data:', error);
            setError('Error fetching data:' + error)
          }
        };

        if(bearerToken.token === '') {
          setError('You are not authorised');
         }
         else {
           fetchData();
         }
      }, [bearerToken.token]); // Empty dependency array ensures this effect runs only once on component mount


      const startOfOccupancyColumn: GridColTypeDef = {
        type: 'date',
        headerName: 'Belegungsstart',
        width: 130,
        valueFormatter: (params: GridValueFormatterParams<Date>) => {
          if (params.value == null) {
            return '';
          }
          const date = new Date(params.value);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}.${month}.${year}`;
        }
      };

      const endOfOccupancyColumn: GridColTypeDef = {
        type: 'date',
        headerName: 'Belegungsende',
        width: 130,
        valueFormatter: (params: GridValueFormatterParams<Date>) => {
          if (params.value == null) {
            return '';
          }
          const date = new Date(params.value);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}.${month}.${year}`;
        }
      };

      const lastUpdateColumn: GridColTypeDef = {
        type: 'date',
        headerName: 'Letzte Meldung vom',
        width: 130,
        valueFormatter: (params: GridValueFormatterParams<Date>) => {
          if (params.value == null) {
            return '';
          }
          const date = new Date(params.value);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}.${month}.${year}`;
        }
      };


      const columns: GridColDef[] = [
         { field: 'id', headerName: '#', width: 150 },
          { field: 'name', headerName: 'Unterkunft', width: 150 },
         { field: 'locationCategory', headerName: 'Kategorie', width: 150 },
         { field: 'district', headerName: 'Bezirk', width: 150 },
         { field: 'address', headerName: 'Adresse', width: 150 },
         { field: 'email', headerName: 'E-Mail', width: 150 },
         { field: 'telefon', headerName: 'Telefon', width: 150 },
         { field: 'startOfOccupancy', ...startOfOccupancyColumn},
         { field: 'endOfOccupancy', ...endOfOccupancyColumn },
         { field: 'lastUpdate', ...lastUpdateColumn },
         { field: 'capacity', headerName: 'Soll-Kapazität', width: 120 },
         { field: 'numberOfOccupiedOru', headerName: 'Ist-Belegung Andere', width: 120 },
         { field: 'numberOfOccupiedUkr', headerName: 'Ist-Belegung Ukraine-Geflüchtete', width: 120 },
         { field: 'numberOfAvailablePlaces', headerName: 'Anzahl freie Plätze', width: 120 },
         { field: 'numberOfReservedSeats', headerName: 'Anzahl nicht belegbare Plätze', width: 120 },
         { field: '', headerName: 'Anzahl nicht belegbare Plätze', width: 120 },
         { field: 'whyNotAssignable', headerName: 'warum nicht belegbar?', width: 120 },
      ];




    function selectGridRow(params: GridRowParams<any>): void {
        navigate("/locations/" + params.row.id)
    }

    return (
        <div>
            <h2>Standorte</h2>
            {
                (!bearerToken.isLoggedIn) && <div>
                  You are not authorised

                  </div>
            }
            {
                (!isLoaded && bearerToken.role === 'Admin') && <div>Loading ...</div>
            }


            {
                (bearerToken.isLoggedIn && bearerToken.role === 'Admin') &&
                <>
                <button onClick={ () => navigate("/locations/new" )}>Add new Location</button>

            <DataGrid onRowClick={selectGridRow}
              rows={history.locations} columns={columns}
              getRowId={(row: any) =>  row.id}

               />

                </>
            }

        {
          (bearerToken.isLoggedIn && bearerToken.role === 'User') &&
          <>
            {/* <DataGrid onRowClick={selectGridRowHoster}
              rows={data} columns={columns}
              getRowId={(row: any) => row.id}
            /> */}
          </>
        }
        </div>
    );
};

export default History;
